<template>
  <div class="grid person" :class="`person--${type}`">
    <div class="grid__col--1 h-no-padding h-center-align">
      <span v-if="icon" class="glyphicon queue-detail__glyph" :class="iconClass" aria-hidden="true"></span>
    </div>
    <div class="grid__col--11 h-no-margin h-no-padding">{{ person.name }}</div>
  </div>
</template>

<script>
  export default {
    name: 'Person',
    props: ['person', 'iconClass', 'icon', 'type'],
  }
</script>
